module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicators-scores-block",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l((_vm.indicators), function(indicator, index) {
    return _c('div', {
      key: indicator.name,
      staticClass: "current-indicator-row"
    }, [_c('div', {
      staticClass: "indicator-score"
    }, [_c('color-block', {
      attrs: {
        "score": _vm.indicatorsColumnA[index].score,
        "isHovered": false,
        "name": ("column B " + (indicator.name))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "indicator-score"
    }, [_c('color-block', {
      attrs: {
        "score": _vm.indicatorsColumnB[index].score,
        "isHovered": false,
        "name": ("column B " + (indicator.name))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "current-indicator-name"
    }, [_vm._v(_vm._s(indicator.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-089a9c66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/IndicatorScoreBlock.vue
// module id = 524
// module chunks = 1